export const issueTypes = [
  {
    label: 'context',
    ariaLabel: '',
    type: 'context',
  },
  {
    label: 'navigationIssues',
    ariaLabel: '',
    type: 'navigationIssues',
  },
  {
    label: 'noLabel',
    ariaLabel: '',
    type: 'noLabel',
  },
  {
    label: 'other',
    ariaLabel: '',
    type: 'other',
  },
];
